import Collapse from '@eversports/react-components/primitives/Collapse'
import Text, { SimpleText } from '@eversports/react-components/primitives/Text'
import { makeStyles } from '@mui/styles'
import React, { useState } from 'react'

import { Localized } from '../../localization/react'
import Venue from '../../typings/Venue'

const useStyles = makeStyles({
  pointer: {
    cursor: 'pointer',
  },
})

interface Props {
  venues: Array<Venue>
}

const ValidVenues: React.FC<React.PropsWithChildren<Props>> = ({ venues }) => {
  const classes = useStyles()
  const [isCollapsed, setIsCollapsed] = useState(true)

  const firstThreeVenues = venues.slice(0, 3)
  const remainingVenues = venues.slice(3, venues.length)

  const handleClick = () => {
    setIsCollapsed(!isCollapsed)
  }

  return (
    <div>
      <Text size="small">
        <Localized id="valid-at" />
      </Text>
      {firstThreeVenues.map((venue) => (
        <Text key={venue.name}>{venue.name}</Text>
      ))}
      {remainingVenues.length > 0 && (
        <>
          <Collapse in={!isCollapsed}>
            {remainingVenues.map((venue) => (
              <SimpleText size="large" key={venue.name}>
                {venue.name}
              </SimpleText>
            ))}
          </Collapse>
          <Text color="secondary.main" className={classes.pointer} onClick={handleClick}>
            {isCollapsed ? <Localized id="show-more" /> : <Localized id="show-less" />}
          </Text>
        </>
      )}
    </div>
  )
}

export default ValidVenues
